module.exports = __webpack_public_path__ + "static/media/dropdownTick.e5cf3719.svg";